var BufferStatusView = require('bufferstatusview');


var ChildStatusView = BufferStatusView.extend({});


module.exports = ChildStatusView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/childstatusview.js
// module id = 4PFu
// module chunks = 1